import { Avatar } from '@/components/Avatar'
import { FormGroup } from '@/components/Form'
import {
  CustomSelect,
  SingleItemSelectedDefault,
} from '@/components/inputs/CustomSelect'
import { useCustomSelectStateFromInfiniteScrollProvider } from '@/components/inputs/infinite-scroll-provider-hook'
import { SearchResultItem } from '@/components/inputs/SearchResultItem'
import { observer } from 'mobx-react-lite'
import { type OwnerSelectorViewModel } from '@/features/jobs/drafting/OwnerSelectorViewModel'

export interface CompactOwnerSelectorContainerProps {
  vm: OwnerSelectorViewModel
}

export const CompactOwnerSelectorContainer = observer(
  function CompactOwnerSelectorContainer({
    vm,
  }: CompactOwnerSelectorContainerProps) {
    const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
      scrollProvider: vm.scroller,
      searchText: vm.searchText.value,
      onSearchTextChange: vm.triggerSearch,
      searchResults: vm.filteredMembers,
    })

    return (
      <FormGroup>
        <CustomSelect
          {...selectProps}
          placeholder="Select client"
          itemToString={(v) => String(v?.displayName)}
          isDisabled={vm.disabled}
          focus$={vm.step.becomeActive$}
          onFocus={vm.step.onBecameActive}
          value={vm.selectedOwner ?? undefined}
          onChange={vm.selectOwner}
          multi={false}
          testId="compact-owner-selector"
          renderItem={(itemProps) => (
            <SingleItemSelectedDefault
              visual={
                <Avatar
                  size={24}
                  subject={{
                    displayName: itemProps.item.displayName,
                    avatar: itemProps.item.avatar,
                  }}
                />
              }
              {...itemProps}
            />
          )}
          renderSearchItem={({
            item,
            itemToString: _itemToString,
            ...itemProps
          }) => (
            <SearchResultItem
              {...itemProps}
              visual={
                <Avatar
                  size={24}
                  subject={{
                    avatar: item.avatar,
                    displayName: item.displayName,
                  }}
                />
              }
            >
              {item.displayName}
            </SearchResultItem>
          )}
        />
      </FormGroup>
    )
  },
)
